var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaryellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8066 3.5916L12.3291 5.17493C12.5652 5.90777 13.2454 6.40596 14.0154 6.40993H15.662C16.4343 6.40503 17.1209 6.90048 17.3597 7.63493C17.5985 8.36937 17.3345 9.17391 16.707 9.6241L15.3533 10.6058C14.7301 11.0582 14.4682 11.8598 14.7041 12.5928L15.2266 14.1762C15.485 14.9117 15.2327 15.7298 14.6049 16.192C13.9771 16.6543 13.121 16.6522 12.4954 16.187L11.1654 15.1974C10.5419 14.7458 9.69882 14.7458 9.07536 15.1974L7.74536 16.187C7.12322 16.6424 6.27816 16.6436 5.65473 16.19C5.03129 15.7364 4.77234 14.932 5.01411 14.1999L5.53661 12.6166C5.7725 11.8835 5.51061 11.0819 4.88744 10.6295L3.50203 9.63201C2.8618 9.18089 2.59333 8.36321 2.84155 7.62039C3.08976 6.87757 3.79588 6.38554 4.57869 6.40993H6.22536C6.99106 6.40821 7.66999 5.91734 7.91161 5.19076L8.43411 3.60743C8.66834 2.8761 9.34669 2.37862 10.1146 2.37502C10.8825 2.37141 11.5655 2.86249 11.8066 3.5916Z",
    fill: "#FEC819"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaryellow);
export default __webpack_public_path__ + "static/media/staryellow.fccf16e6f392374aeda3340c6322c8cc.svg";
export { ForwardRef as ReactComponent };